import React from "react";
import { getAvatarColors, getInitials } from "../../helpers/avatarColors";

interface LocalAvatarProps {
  name: string;
  size?: number;
  style?: React.CSSProperties;
  className?: string;
}

export const LocalAvatar: React.FC<LocalAvatarProps> = ({
  name,
  size = 24,
  style = {},
  className = "",
}) => {
  const colors = getAvatarColors(name);
  const initials = getInitials(name);

  const avatarStyle: React.CSSProperties = {
    width: size,
    height: size,
    borderRadius: "50%",
    backgroundColor: colors.backgroundColor,
    color: colors.textColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: Math.floor(size * 0.5),
    fontWeight: "bold",
    fontFamily: "inherit",
    textTransform: "uppercase",
    border: "none",
    ...style,
  };

  return (
    <div
      className={`local-avatar ${className}`}
      style={avatarStyle}
      title={`Avatar for ${name}`}
    >
      {initials}
    </div>
  );
};
